import {
  PropsWithChildren,
  useRef,
  useLayoutEffect,
  ReactElement,
} from 'react';

import classNames from 'classnames';
import { IonFooter, IonToolbar } from '@ionic/react';

import { FooterActions } from './FooterActions/FooterActions';

import styles from './Footer.module.scss';

export type FooterProps = PropsWithChildren<{
  shadow?: boolean;
  className?: string;
}>;

interface FooterComponent {
  (props: FooterProps): ReactElement;
  Actions: typeof FooterActions;
}

export const Footer: FooterComponent = ({
  children,
  className,
  shadow = false,
}) => {
  const toolbar = useRef<HTMLIonToolbarElement>();

  useLayoutEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .toolbar-container {
        margin: 0 auto;
        max-width: var(--max-content-width);
      }
    `;
    toolbar.current.shadowRoot.appendChild(style);
  }, []);

  return (
    <IonFooter
      collapse="fade"
      className={classNames(
        styles.root,
        'ion-no-border',
        'ion-padding',
        {
          [styles.shadow]: shadow,
        },
        className
      )}
    >
      <IonToolbar ref={toolbar} className={classNames(styles.toolbar)}>
        {children}
      </IonToolbar>
    </IonFooter>
  );
};

Footer.Actions = FooterActions;
